import FormGroupText from './FormGroupText'

export default {
    Text: FormGroupText
}



// WEBPACK FOOTER //
// src/components/FormGroup/index.js